import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Guid } from 'guid-typescript';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth.service';
import { environment } from 'src/environments/environment';
import { IIndicatorAnalysisListItemDto, IIndicatorStorageDto } from '../indicator-api/indicator-api.interfaces';

@Injectable({
  providedIn: 'root'
})
export class AnalysisApiService {
  controllerUrl: string = 'analysis';

  private readonly authService: AuthService = inject(AuthService);
  private readonly httpClient: HttpClient = inject(HttpClient);

  getAll(): Observable<IIndicatorAnalysisListItemDto[]> {
    const options = {
      headers: new HttpHeaders({ 'apiKey': this.authService.getApiKey().toString() }),
    };

    return this.httpClient.get<IIndicatorAnalysisListItemDto[]>(`${environment.analysisApiUrl}/${this.controllerUrl}`, options);
  }

  triggerAnalysisFromUploadReferenceId(uploadReferenceId: Guid): Observable<Guid> {
    const options = {
      headers: new HttpHeaders({ 'apiKey': this.authService.getApiKey().toString() }),
      params: new HttpParams().set('uploadReferenceId', uploadReferenceId.toString())
    };

    return this.httpClient.post<Guid>(`${environment.analysisApiUrl}/${this.controllerUrl}`, null, options);
  }

  getIndicatorPerAnalysisId(indicatorName: string, analysisId: Guid): Observable<IIndicatorStorageDto[]> {
    const options = {
      headers: new HttpHeaders({ 'apiKey': this.authService.getApiKey().toString() }),
      params: new HttpParams().set('indicatorName', indicatorName)
                              .set('analysisId', analysisId.toString())
    };

    return this.httpClient.get<IIndicatorStorageDto[]>(`${environment.analysisApiUrl}/${this.controllerUrl}/GetIndicatorPerAnalysisId`, options);
  }
}
